export enum PositionDateField {    
    KidneyPickupDateTime = 1,
    KidneyArrivalDateTime = 2,
    MatchOfferDeadlineDateTime = 3,
    CrossMatchDeadlineDateTime = 4
}